import { formatRegion } from '@platform/design-system';

type ShopFacts = { readonly country: string; readonly currency: string };

const DETAIL_SEPARATOR = ' · ';

export const shopDetailOf = (shop: ShopFacts, locale: string): string =>
  [formatRegion(shop.country, locale), shop.currency].join(DETAIL_SEPARATOR);

export const shopSummaryOf = (shop: ShopFacts & { readonly name: string }, locale: string): string =>
  [shop.name, shopDetailOf(shop, locale)].join(DETAIL_SEPARATOR);
